/* istanbul ignore file */
import React from 'react';
import properties from 'properties';
import AppUtil, { getAppStore } from 'js/utils/AppUtil';
import AppHelper from 'js/app/AppHelper';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import { APP_URL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import isFeatureEnable from 'js/utils/FeatureUtil';

export const addNewIssue = data => {
    return () => {
        const url = properties.url + APP_URL_CONSTANTS.ADD_NEW_ISSUE + "/" + AppHelper.getParamData("icentid") + "/" +
            AppHelper.getAppData("project").projectcode.replace(/\//g, "EWREscalatedSlash") + "/" + AppHelper.getAppData("project").source_projectid + "/" +
            AppHelper.getAppData("enterprise").source_loginid + "/" + AppHelper.getAppData("issueCollector").id + '/' + 
            isFeatureEnable('attachmentRESTV2');
        const appStore = getAppStore();

        AppUtil.ajax(url, data, response => {
            if (response.data) {
                const message = (
                    <span>You have successfully raised a request <label className='bold ic_success_msg_bold'>{ response.data.ItemCode }</label>.</span>
                );
    
                appStore.dispatch( showMessage({
                    message,
                    type: BOARD_MESSAGE_CONSTANT.TYPE_SUCCESS,
                    showMainBox: true,
                    onConfirmFn: () => { 
                        if ( window.name ) {
                            window.parent.postMessage("CloseIssueCollectorWindow", "*");
                        } else {
                            window.location.reload();
                        }
                    }
                }) );
            }
            if ( response.m_errorList ) {
                AppUtil.getErrorMessage(response)
           }
        });
    }
}